export default "__VITE_ASSET__tonNsbi1__"